module.exports = __webpack_public_path__ + "static/img/箭牌家居.36d31bd0.png";